import React from 'react';

interface PageLoadingSpinnerProps
  extends React.HTMLAttributes<HTMLDivElement> {}

export const PageLoadingSpinner: React.FC<PageLoadingSpinnerProps> = props => (
  <div
    role="status"
    aria-live="polite"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: 120,
      ...props.style,
    }}
    {...props}
  >
    Loading...
  </div>
);
